import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCookie } from '../utils/cookies';

const LevelSelect: React.FC = () => {
  const navigate = useNavigate();
  const [unlocked, setUnlocked] = useState(1);

  useEffect(() => {
    if (!getCookie('playerName') || !getCookie('playerPhone')) {
      navigate('/');
      return;
    }
    setUnlocked(Number(getCookie('unlockedLevel') || '1'));
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 via-blue-500 to-indigo-600 flex flex-col items-center py-10 px-4">
      <h1 className="text-3xl font-bold text-white mb-8">Select Level</h1>
      <div className="grid grid-cols-3 gap-4 w-full max-w-sm">
        {Array.from({ length: 9 }).map((_, i) => {
          const lvl = i + 1;
          const isLocked = lvl > unlocked;
          return (
            <button
              key={lvl}
              disabled={isLocked}
              onClick={() => navigate(`/game/${lvl}`)}
              className={[
                'aspect-square rounded-2xl flex items-center justify-center text-2xl font-bold shadow-lg transition-transform',
                isLocked ? 'bg-white/30 text-white/60 cursor-not-allowed' : 'bg-white text-indigo-600 hover:scale-105',
              ].join(' ')}
            >
              {isLocked ? '🔒' : lvl}
            </button>
          );
        })}
      </div>
      {unlocked >= 9 && (
        <p className="text-white/80 text-sm mt-6 text-center max-w-xs">
          Level 9 is the ultimate challenge — good luck! 🔥
        </p>
      )}
    </div>
  );
};

export default LevelSelect;